import { beforeAttack, defineGameCard, oncePerRound } from '../authoring/index.js';
import { residueStacks, slimeDependencies, spendSlimeResidue, trail } from './slime-helpers.js';
export const SlipperySlimeCard = defineGameCard({
    id: 'slippery_slime',
    gameplay: {
        type: 'UNIT', cost: 2, baseStats: { attack: 3, health: 1 }, traits: ['SLIME'], keywords: ['RUSH'],
    },
    presentation: {
        name: 'Скользень',
        description: 'Натиск. След 1. Первый раз за раунд перед атакой по Скользню снимите 2 Склизи с его ячейки, если возможно. Эта атака промахивается.',
        glyph: {
            colors: ['#10213A', '#74AD4C', '#61A5BE', '#5E984F', '#96C653'],
            rows: [
                '....................',
                '....................',
                '....................',
                '....................',
                '...........1...1....',
                '...........21.12....',
                '............1.1.....',
                '...3.......144211...',
                '.3.3.3....14422221..',
                '.........144222121..',
                '..33..111442222221..',
                '.....1444442222541..',
                '.3..1444452222541...',
                '...3331144554441....',
                '....333311444413....',
                '.....33333111133....',
                '......333333333.....',
                '....................',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: slimeDependencies(),
    abilities: [
        trail(),
        beforeAttack(oncePerRound({
            abilityId: 'residue_dodge',
            trigger: 'interceptAttack',
            when: (ctx, planned) => ctx.self?.cellId !== undefined
                && planned.target.kind === 'unit'
                && planned.target.instanceId === ctx.self.id
                && residueStacks(ctx, ctx.self.cellId) >= 2,
            run: (ctx) => {
                const avoided = ctx.self?.cellId !== undefined
                    && spendSlimeResidue(ctx, ctx.self.cellId, 2);
                return { abilityId: 'residue_dodge', avoided };
            },
        })),
    ],
    ui: { mechanics: ['rush', 'trail', 'slime_residue', 'dodge'] },
});
//# sourceMappingURL=slippery_slime.js.map